import { render } from "./VariantImage.vue?vue&type=template&id=97deb604&lang=pug"
import script from "./VariantImage.vue?vue&type=script&lang=js"
export * from "./VariantImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__